/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as AuthRedirectRouteImport } from './routes/auth/redirect'
import { Route as AuthenticatedDealReviewRouteImport } from './routes/_authenticated/deal-review'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedCompaniesRouteImport } from './routes/_authenticated/companies'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedActualVsBudgetRouteImport } from './routes/_authenticated/actual-vs-budget'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedExperimentsActualVsBudgetRouteImport } from './routes/_authenticated/experiments/actual-vs-budget'
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from './routes/_authenticated/companies/$companyId'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminChronographRouteImport } from './routes/_authenticated/admin/chronograph'
import { Route as AuthenticatedCompaniesViewsViewIdRouteImport } from './routes/_authenticated/companies/views/$viewId'
import { Route as AuthenticatedCompaniesCompanyIdOgsmRouteImport } from './routes/_authenticated/companies/$companyId_.ogsm'

const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const AuthRedirectRoute = AuthRedirectRouteImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedDealReviewRoute = AuthenticatedDealReviewRouteImport.update({
  id: '/deal-review',
  path: '/deal-review',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompaniesRoute = AuthenticatedCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActualVsBudgetRoute =
  AuthenticatedActualVsBudgetRouteImport.update({
    id: '/actual-vs-budget',
    path: '/actual-vs-budget',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompaniesRoute,
  } as any)
const AuthenticatedExperimentsActualVsBudgetRoute =
  AuthenticatedExperimentsActualVsBudgetRouteImport.update({
    id: '/experiments/actual-vs-budget',
    path: '/experiments/actual-vs-budget',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => AuthenticatedCompaniesRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminChronographRoute =
  AuthenticatedAdminChronographRouteImport.update({
    id: '/chronograph',
    path: '/chronograph',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedCompaniesViewsViewIdRoute =
  AuthenticatedCompaniesViewsViewIdRouteImport.update({
    id: '/views/$viewId',
    path: '/views/$viewId',
    getParentRoute: () => AuthenticatedCompaniesRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdOgsmRoute =
  AuthenticatedCompaniesCompanyIdOgsmRouteImport.update({
    id: '/$companyId_/ogsm',
    path: '/$companyId/ogsm',
    getParentRoute: () => AuthenticatedCompaniesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/portal': typeof PortalRouteWithChildren
  '/actual-vs-budget': typeof AuthenticatedActualVsBudgetRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/companies': typeof AuthenticatedCompaniesRouteWithChildren
  '/contacts': typeof AuthenticatedContactsRoute
  '/deal-review': typeof AuthenticatedDealReviewRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/portal/': typeof PortalIndexRoute
  '/admin/chronograph': typeof AuthenticatedAdminChronographRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/experiments/actual-vs-budget': typeof AuthenticatedExperimentsActualVsBudgetRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/companies/$companyId/ogsm': typeof AuthenticatedCompaniesCompanyIdOgsmRoute
  '/companies/views/$viewId': typeof AuthenticatedCompaniesViewsViewIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/actual-vs-budget': typeof AuthenticatedActualVsBudgetRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/contacts': typeof AuthenticatedContactsRoute
  '/deal-review': typeof AuthenticatedDealReviewRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/portal': typeof PortalIndexRoute
  '/admin/chronograph': typeof AuthenticatedAdminChronographRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/experiments/actual-vs-budget': typeof AuthenticatedExperimentsActualVsBudgetRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/companies/$companyId/ogsm': typeof AuthenticatedCompaniesCompanyIdOgsmRoute
  '/companies/views/$viewId': typeof AuthenticatedCompaniesViewsViewIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/portal': typeof PortalRouteWithChildren
  '/_authenticated/actual-vs-budget': typeof AuthenticatedActualVsBudgetRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/companies': typeof AuthenticatedCompaniesRouteWithChildren
  '/_authenticated/contacts': typeof AuthenticatedContactsRoute
  '/_authenticated/deal-review': typeof AuthenticatedDealReviewRoute
  '/auth/redirect': typeof AuthRedirectRoute
  '/portal/': typeof PortalIndexRoute
  '/_authenticated/admin/chronograph': typeof AuthenticatedAdminChronographRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/_authenticated/experiments/actual-vs-budget': typeof AuthenticatedExperimentsActualVsBudgetRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/companies/$companyId_/ogsm': typeof AuthenticatedCompaniesCompanyIdOgsmRoute
  '/_authenticated/companies/views/$viewId': typeof AuthenticatedCompaniesViewsViewIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/portal'
    | '/actual-vs-budget'
    | '/admin'
    | '/companies'
    | '/contacts'
    | '/deal-review'
    | '/auth/redirect'
    | '/portal/'
    | '/admin/chronograph'
    | '/admin/users'
    | '/companies/$companyId'
    | '/experiments/actual-vs-budget'
    | '/companies/'
    | '/companies/$companyId/ogsm'
    | '/companies/views/$viewId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/actual-vs-budget'
    | '/admin'
    | '/contacts'
    | '/deal-review'
    | '/auth/redirect'
    | '/portal'
    | '/admin/chronograph'
    | '/admin/users'
    | '/companies/$companyId'
    | '/experiments/actual-vs-budget'
    | '/companies'
    | '/companies/$companyId/ogsm'
    | '/companies/views/$viewId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/portal'
    | '/_authenticated/actual-vs-budget'
    | '/_authenticated/admin'
    | '/_authenticated/companies'
    | '/_authenticated/contacts'
    | '/_authenticated/deal-review'
    | '/auth/redirect'
    | '/portal/'
    | '/_authenticated/admin/chronograph'
    | '/_authenticated/admin/users'
    | '/_authenticated/companies/$companyId'
    | '/_authenticated/experiments/actual-vs-budget'
    | '/_authenticated/companies/'
    | '/_authenticated/companies/$companyId_/ogsm'
    | '/_authenticated/companies/views/$viewId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PortalRoute: typeof PortalRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/auth/redirect': {
      id: '/auth/redirect'
      path: '/redirect'
      fullPath: '/auth/redirect'
      preLoaderRoute: typeof AuthRedirectRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/deal-review': {
      id: '/_authenticated/deal-review'
      path: '/deal-review'
      fullPath: '/deal-review'
      preLoaderRoute: typeof AuthenticatedDealReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts': {
      id: '/_authenticated/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedContactsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies': {
      id: '/_authenticated/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/actual-vs-budget': {
      id: '/_authenticated/actual-vs-budget'
      path: '/actual-vs-budget'
      fullPath: '/actual-vs-budget'
      preLoaderRoute: typeof AuthenticatedActualVsBudgetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedCompaniesRoute
    }
    '/_authenticated/experiments/actual-vs-budget': {
      id: '/_authenticated/experiments/actual-vs-budget'
      path: '/experiments/actual-vs-budget'
      fullPath: '/experiments/actual-vs-budget'
      preLoaderRoute: typeof AuthenticatedExperimentsActualVsBudgetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$companyId': {
      id: '/_authenticated/companies/$companyId'
      path: '/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedCompaniesRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/chronograph': {
      id: '/_authenticated/admin/chronograph'
      path: '/chronograph'
      fullPath: '/admin/chronograph'
      preLoaderRoute: typeof AuthenticatedAdminChronographRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/companies/views/$viewId': {
      id: '/_authenticated/companies/views/$viewId'
      path: '/views/$viewId'
      fullPath: '/companies/views/$viewId'
      preLoaderRoute: typeof AuthenticatedCompaniesViewsViewIdRouteImport
      parentRoute: typeof AuthenticatedCompaniesRoute
    }
    '/_authenticated/companies/$companyId_/ogsm': {
      id: '/_authenticated/companies/$companyId_/ogsm'
      path: '/$companyId/ogsm'
      fullPath: '/companies/$companyId/ogsm'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdOgsmRouteImport
      parentRoute: typeof AuthenticatedCompaniesRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminChronographRoute: typeof AuthenticatedAdminChronographRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminChronographRoute: AuthenticatedAdminChronographRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedCompaniesRouteChildren {
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedCompaniesCompanyIdOgsmRoute: typeof AuthenticatedCompaniesCompanyIdOgsmRoute
  AuthenticatedCompaniesViewsViewIdRoute: typeof AuthenticatedCompaniesViewsViewIdRoute
}

const AuthenticatedCompaniesRouteChildren: AuthenticatedCompaniesRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdRoute: AuthenticatedCompaniesCompanyIdRoute,
    AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
    AuthenticatedCompaniesCompanyIdOgsmRoute:
      AuthenticatedCompaniesCompanyIdOgsmRoute,
    AuthenticatedCompaniesViewsViewIdRoute:
      AuthenticatedCompaniesViewsViewIdRoute,
  }

const AuthenticatedCompaniesRouteWithChildren =
  AuthenticatedCompaniesRoute._addFileChildren(
    AuthenticatedCompaniesRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedActualVsBudgetRoute: typeof AuthenticatedActualVsBudgetRoute
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedCompaniesRoute: typeof AuthenticatedCompaniesRouteWithChildren
  AuthenticatedContactsRoute: typeof AuthenticatedContactsRoute
  AuthenticatedDealReviewRoute: typeof AuthenticatedDealReviewRoute
  AuthenticatedExperimentsActualVsBudgetRoute: typeof AuthenticatedExperimentsActualVsBudgetRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActualVsBudgetRoute: AuthenticatedActualVsBudgetRoute,
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedCompaniesRoute: AuthenticatedCompaniesRouteWithChildren,
  AuthenticatedContactsRoute: AuthenticatedContactsRoute,
  AuthenticatedDealReviewRoute: AuthenticatedDealReviewRoute,
  AuthenticatedExperimentsActualVsBudgetRoute:
    AuthenticatedExperimentsActualVsBudgetRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuthRouteChildren {
  AuthRedirectRoute: typeof AuthRedirectRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthRedirectRoute: AuthRedirectRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PortalRouteChildren {
  PortalIndexRoute: typeof PortalIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalIndexRoute: PortalIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
